(function() {
  'use strict';

  angular
    .module('admin.notification_history.service', [])
    .factory('NotificationHistoryService', NotificationHistoryService);

  /** @ngInject */
  function NotificationHistoryService($http, $q, API) {

    function list(){
        var defered = $q.defer();

        $http.get(API.API_URL + 'admin/push_notifications')
          .success(defered.resolve);

        return defered.promise;
    }

    function listUnpublished(start, limit, sort){
        var defered = $q.defer();

        $http.get(API.API_URL + 'admin/push_notifications/unpublished?start=' + start + '&limit=' + limit + '&sort=' + sort)
          .success(defered.resolve);

        return defered.promise;
    }

    function listPublished(start, limit, sort){
        var defered = $q.defer();

        $http.get(API.API_URL + 'admin/push_notifications/published?start=' + start + '&limit=' + limit + '&sort=' + sort)
          .success(defered.resolve);

        return defered.promise;
    }

    function get(id){
        var defered = $q.defer();

        $http.get(API.API_URL + 'admin/push_notifications/' + id)
          .success(defered.resolve);

        return defered.promise;
    }

    function save(model){
        var defered = $q.defer();

        $http.post(API.API_URL + 'admin/push_notifications', model)
          .success(defered.resolve);

        return defered.promise;
    }

    function update(id, model){
        var defered = $q.defer();

        $http.post(API.API_URL + 'admin/push_notifications/' + id, model)
          .success(defered.resolve);

        return defered.promise;
    }

    function remove(id){
        var defered = $q.defer();

        $http.delete(API.API_URL + 'admin/push_notifications/' + id)
          .success(defered.resolve);

        return defered.promise;
    }

    function publish(id){
        var defered = $q.defer();

        $http.post(API.API_URL + 'admin/push_notifications/' + id + '/publish')
          .success(defered.resolve);

        return defered.promise;
    }

    function unpublish(id){
        var defered = $q.defer();

        $http.post(API.API_URL + 'admin/push_notifications/' + id + '/unpublish')
          .success(defered.resolve);

        return defered.promise;
    }

    return{
       list: list,
       listUnpublished: listUnpublished,
       listPublished: listPublished,
       get: get,
       save: save,
       update: update,
       remove: remove,
       publish: publish,
       unpublish: unpublish
    };

  }

})();
